import React, { useEffect } from "react";
import "./Partenaires.scss";
import AOS from "aos";
import "aos/dist/aos.css";
import TrustIndexWidget from "../../sections/TrustIndexWidget/TrustIndexWidget";
import Contact from "../../sections/Contact/Contact";
import { Helmet } from "react-helmet";

function Partenaires() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <div>
      <Helmet>
        <title>Partenaires | Pokélu</title>
        <meta
          name="description"
          key="description"
          content="Nos partenaires partagent nos valeurs et nous accompagnent pour offrir des solutions adaptées, 
            respectueuses et bienveillantes à vos compagnons."
        />
      </Helmet>
      <section id="partenaires" className="section-container">
        <div>
          <h1 className="title">Mes partenaires</h1>
          <div className="flex-container">
            <div className="text-content" data-aos="fade-right">
              <p>
                Parce que le <strong>bien-être</strong> de vos animaux est une
                priorité, nous collaborons avec des professionnels engagés et
                passionnés. Nos partenaires partagent nos valeurs et nous
                accompagnent pour offrir des{" "}
                <strong>
                  solutions adaptées, respectueuses et bienveillantes
                </strong>{" "}
                à vos compagnons.
              </p>
            </div>
            <div className="image-container" data-aos="fade-left">
              <img
                src="/img/partenaires/collaboration.webp"
                alt="collaboration partenaires"
              />
            </div>
          </div>
          <div>
            <div className="partenaires-container">
              <div data-aos="fade-up" className="flex">
                <img src="/img/partenaires/sakoAndCo.webp" alt="Sako&Co" />
                <div>
                  <h2 className="title">Sako&Co</h2>
                  <div className="text-content">
                    <p>
                      Chez Sako&Co retrouvez des produits sélectionnés avec
                      soin, des{" "}
                      <strong>produits durables, naturels et sains</strong> pour
                      vos compagnons à quatre pattes. Friandises naturelles,
                      recettes ou encore tapis de léchage et jouet masticatoire,
                      il y en a pour tous les goûts !
                    </p>
                    <p>
                      Pour célébrer votre première commande, bénéficiez d’un
                      avantage de <strong>10%</strong> sur l’ensemble de votre
                      panier avec le code <strong>POKELU10</strong> !
                    </p>
                  </div>
                  <a
                    href="https://sakoandco.fr/"
                    target="_blank"
                    className="custom-card-button"
                    rel="noreferrer"
                  >
                    Visiter la boutique
                  </a>
                </div>
              </div>

              <div data-aos="fade-up" className="flex reverse">
                <img
                  src="/img/partenaires/o-bout-de-la-plume.webp"
                  alt="O'bout de la plume"
                />
                <div>
                  <h2 className="title">O'Bout de la Plume</h2>
                  <div className="text-content">
                    <p>
                      Chez O’Bout de la Plume retrouvez des{" "}
                      <strong>jouets et accessoires faits mains</strong> pour
                      vos chats dans son atelier Toulousain depuis 2017.
                      Créations 100% testées sur ses Maine Coon pour plus de
                      fiabilité.
                    </p>
                  </div>
                  <a
                    href="https://www.oboutdelaplume.com/"
                    target="_blank"
                    className="custom-card-button"
                    rel="noreferrer"
                  >
                    Visiter la boutique
                  </a>
                </div>
              </div>

              <div data-aos="fade-up" className="flex">
                <img
                  src="/img/partenaires/seconde-patte.jpeg"
                  alt="Seconde Patte"
                />
                <div>
                  <h2 className="title">Seconde Patte</h2>
                  <div className="text-content">
                    <p>
                      Seconde Patte donne une{" "}
                      <strong>seconde vie aux accessoires pour animaux</strong>{" "}
                      en les récupérant, réparant et revalorisant. Une{" "}
                      <strong>alternative économique et responsable</strong>{" "}
                      pour équiper vos compagnons à moindre coût tout en
                      réduisant le gaspillage.
                    </p>
                  </div>
                  <a
                    href="https://www.boutique-secondepatte.com"
                    target="_blank"
                    className="custom-card-button"
                    rel="noreferrer"
                  >
                    Visiter la boutique
                  </a>
                </div>
              </div>

              <div data-aos="fade-up" className="flex reverse">
                <img
                  src="/img/partenaires/nourrir-comme-la-nature.png"
                  alt="Nourrir Comme la Nature"
                />
                <div>
                  <h2 className="title">Nourrir Comme la Nature</h2>
                  <div className="text-content">
                    <p>
                      Nourrir Comme la Nature propose une <strong>alimentation de
                      qualité, adaptée aux besoins réels de vos animaux</strong>. Leur
                      sélection de croquettes premium respecte la physiologie de
                      chaque chien et chat.
                    </p>
                    <p>
                    En tant que client, bénéficiez d’un <strong>code de réduction
                      exclusif</strong> pour vos achats sur leur site !
                    </p>
                  </div>
                  <a
                    href="https://www.nourrircommelanature.com"
                    target="_blank"
                    className="custom-card-button"
                    rel="noreferrer"
                  >
                    Découvrir la boutique
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <TrustIndexWidget /> */}
      <Contact />
    </div>
  );
}

export default Partenaires;
